<template>
  <div class="right_content">
    <div class="p-title">{{ title || '标题' }}</div>
    <div class="p-main">
      <slot></slot>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  data () {
    return {}
  },
  props: {
    title: String
  },
  methods: {}
}
</script>

<style lang="sass">
.right_content
  overflow: hidden
</style>